import { IBridgeProvidedAction } from "@vega/bridge";

export const OpenCustomerByCustomerIdActionId = "open-customer-by-customerId";

export class OpenCustomerByCustomerIdActionData {
    public customerId: number | undefined;
}

export type OpenCustomerByCustomerIdAction = IBridgeProvidedAction<OpenCustomerByCustomerIdActionData, void>;
